import React, { useState, useEffect, useImperativeHandle } from "react";
import {
  Dropdown,
  DropdownToggle,
  Input,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";
import { toast } from "react-toastify";
import { fetchCountryCurrency } from "../../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { getBenefitValues } from "../../../../../../settings/src/store/benefits/action";
import BenefitPayRateElement from "./BenefitPayRateElement";
import BenefitTableElement from "./BenefitTableElement";
import { isJsonString } from "../../../../helpers/json_helper";

const BenefitsCustomElement = ({ formStateHook, field, formik }) => {
  const { formState } = formStateHook;

  const benefitTypes = ["Monetory", "Non-Monetory"];

  const dispatch = useDispatch();
  const countryData = useSelector(
    (state) => state.CountryCurrencyReducer.countryCurrency
  );
  const benefitValuesSelector = useSelector(
    (state) => state.BenefitsReducer.benefitValues
  );

  const [benefitValues, setBenefitValues] = useState([]);

  // Country & Filter
  const [countryDropdown, setCountryDropdown] = useState(false);
  const [benifitTypeDropdown, setBenefitTypeDropdrown] = useState(false);
  const [benifitValueDropdown, setBenefitValueDropdrown] = useState(false);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedBenefitType, setSelectedBenefitType] = useState(null);
  const [selectedBenefitValue, setSelectedBenefitValue] = useState(null);
  const [payrate, setPayrate] = useState(null);
  const [tableData, setTableData] = useState([]);

  //Search element
  const [countrySearchTerm, setCountrySearchTerm] = useState("");
  const [benefitTypeSearchTerm, setBenefitTypeSearchTerm] = useState("");
  const [benefitValueSearchTerm, setBenefitValueSearchTerm] = useState("");

  const [dataLoaded, setDataLoaded] = useState(false);

  const [editKey, setEditKey] = useState(null);

  useEffect(() => {
    if (!dataLoaded && formik?.values?.[field?.name]) {
      if (isJsonString(formik?.values?.[field?.name])) {
        setTableData(JSON.parse(formik?.values?.[field?.name]));
      }
      setDataLoaded(true);
    }
  }, [formik?.values?.[field?.name]]);

  // Fetch country currency
  useEffect(() => {
    if (!countryData) {
      dispatch(fetchCountryCurrency());
    }
  }, []);

  useEffect(() => {
    if (selectedCountry && selectedBenefitType) {
      dispatch(
        getBenefitValues({
          country: selectedCountry,
          type: selectedBenefitType,
        })
      );
    }
  }, [selectedCountry, selectedBenefitType]);

  useEffect(() => {
    if (benefitValuesSelector) {
      const values = benefitValuesSelector?.map((dt) => dt?.value);
      setBenefitValues(values ?? []);
    }
  }, [benefitValuesSelector]);

  useEffect(() => {
    if (tableData?.length > 0) {
      formik.setFieldValue(field.name, JSON.stringify(tableData));
      formik.setFieldError(field.name, "");
    } else {
      // Added as delete all the table data is causing error.
      if (field.name in formik.values) {
        formik.setFieldValue(field.name, "");
      }
    }
  }, [tableData]);

  const toggleCountryDropdown = () =>
    setCountryDropdown((prevState) => !prevState);

  const toggleBenefitTypeDropdown = () =>
    setBenefitTypeDropdrown((prevState) => !prevState);

  const toggleBenifitValueDropdown = () =>
    setBenefitValueDropdrown((prevState) => !prevState);

  const filteredCountry = countrySearchTerm
    ? countryData?.filter((country) => {
        let countryName = `${country.name}`;
        return countryName
          .toLowerCase()
          .includes(countrySearchTerm.toLowerCase());
      })
    : countryData;

  const filteredBenefitType = benefitTypeSearchTerm
    ? benefitTypes.filter((data) => {
        let benefitType = `${data}`;
        return benefitType
          .toLowerCase()
          .includes(benefitTypeSearchTerm.toLowerCase());
      })
    : benefitTypes;

  const filteredBenefitValue = benefitValueSearchTerm
    ? benefitValues.filter((data) => {
        let benefitValue = `${data}`;
        return benefitValue
          .toLowerCase()
          .includes(benefitValueSearchTerm.toLowerCase());
      })
    : benefitValues;

  const handleChangeType = (type) => {
    setSelectedBenefitType(type);
    setCountrySearchTerm("");
    setBenefitTypeSearchTerm("");
    setBenefitValueSearchTerm("");
    setSelectedBenefitValue(null);
    setPayrate(null);
  };

  const handleAdd = () => {
    if (
      !selectedCountry ||
      !selectedBenefitType ||
      !selectedBenefitValue ||
      !payrate
    ) {
      toast.error("Please fill all the fields then add.");
      return;
    }

    let canAdd = true;
    const key = `${selectedCountry.trim()}//${selectedBenefitType.trim()}//${selectedBenefitValue.trim()}`;
    if (tableData?.length > 0) {
      const exists = tableData.find((data) => data?.key === key);
      if (exists) {
        canAdd = false;
      }
    }
    if (canAdd) {
      const data = {
        key: `${selectedCountry.trim()}//${selectedBenefitType.trim()}//${selectedBenefitValue.trim()}`,
        country: selectedCountry.trim(),
        type: selectedBenefitType.trim(),
        benefit: selectedBenefitValue.trim(),
        value: payrate,
      };
      setTableData((prevState) => [data, ...prevState]);
    } else {
      toast.error("Benefit already exists.");
    }
  };

  const handleDel = (key) => {
    const newTable = tableData.filter((dt) => dt?.key !== key);
    setTableData(newTable);
  };

  const handleEditTable = (key) => {
    const data = tableData.find((dt) => dt?.key === key);
    setSelectedCountry(data?.country);
    setSelectedBenefitType(data?.type);
    setSelectedBenefitValue(data?.benefit);
    setPayrate(data?.value);
    setEditKey(key);
  };

  const handleCancel = () => {
    setSelectedCountry(null);
    setSelectedBenefitType(null);
    setSelectedBenefitValue(null);
    setPayrate("");
    setEditKey(null);
  };

  const handleEdit = (key) => {
    if (key === null) {
      handleCancel();
      return;
    }

    // Check  if all the fields are filled
    if (
      !selectedCountry ||
      !selectedBenefitType ||
      !selectedBenefitValue ||
      !payrate
    ) {
      toast.error("Please fill all the fields then add.");
      return;
    }

    const generateNewKey = `${selectedCountry.trim()}//${selectedBenefitType.trim()}//${selectedBenefitValue.trim()}`;
    const filteredTable = tableData.filter((dt) => dt?.key !== key);
    // Check if the new key is already present in the table
    const exists = filteredTable.find((data) => data?.key === generateNewKey);
    if (exists) {
      toast.error("Benefit already exists.");
      return;
    }

    // Replace the data in the table where key matches
    const newTable = tableData.map((dt) => {
      if (dt?.key === key) {
        dt.key = generateNewKey;
        dt.country = selectedCountry.trim();
        dt.type = selectedBenefitType.trim();
        dt.benefit = selectedBenefitValue.trim();
        dt.value = payrate;
      }
      return dt;
    });
    setTableData(newTable);
    handleCancel();
  };

  return (
    <div>
      <div className="d-flex flex-column row-gap-4 justify-content-end">
        <div>
          <div className="input-group">
            <Dropdown
              className="dropdown"
              isOpen={countryDropdown}
              toggle={toggleCountryDropdown}
              tabIndex="1"
              style={{ flex: 1 }}
            >
              <DropdownToggle
                as="button"
                className="btn btn-light arrow-none"
                style={{ borderColor: "#d3d3d3", width: "100%" }}
                disabled={formState === "view" ? true : false}
                tabIndex={2}
              >
                <span>{selectedCountry ?? "Country"}</span>
              </DropdownToggle>
              <DropdownMenu
                as="ul"
                className="list-unstyled w-200 dropdown-menu-list mb-0 overflow-auto"
                style={{ maxHeight: "240px" }}
              >
                <Input
                  type="text"
                  className="form-control search m-auto"
                  placeholder="Search currency..."
                  value={countrySearchTerm}
                  style={{ borderColor: "#d3d3d3" }}
                  onChange={(e) => setCountrySearchTerm(e.target.value)}
                />
                {filteredCountry &&
                  filteredCountry.map((country) => (
                    <DropdownItem
                      key={country.id}
                      as="li"
                      onClick={() => setSelectedCountry(country.name)}
                      className="dropdown-item d-flex"
                    >
                      <div className="flex-grow-1">
                        <div className="d-flex">
                          <span>{`${country.name}`}</span>
                        </div>
                      </div>
                    </DropdownItem>
                  ))}
              </DropdownMenu>
            </Dropdown>
            <Dropdown
              className="dropdown"
              isOpen={benifitTypeDropdown}
              toggle={toggleBenefitTypeDropdown}
              tabIndex="1"
              style={{ flex: 1 }}
            >
              <DropdownToggle
                as="button"
                className="btn btn-light arrow-none"
                style={{ borderColor: "#d3d3d3", width: "100%" }}
                disabled={formState === "view" ? true : false}
              >
                <span>{selectedBenefitType ?? "Benefit Type"}</span>
              </DropdownToggle>
              <DropdownMenu
                as="ul"
                className="list-unstyled w-100 dropdown-menu-list mb-0 overflow-auto"
                style={{ maxHeight: "240px" }}
              >
                <Input
                  type="text"
                  className="form-control search m-auto"
                  placeholder="Search frequency..."
                  value={benefitTypeSearchTerm}
                  style={{ borderColor: "#d3d3d3" }}
                  onChange={(e) => setBenefitTypeSearchTerm(e.target.value)}
                />
                {filteredBenefitType &&
                  filteredBenefitType.map((type) => (
                    <DropdownItem
                      key={type}
                      as="li"
                      onClick={() => handleChangeType(type)}
                      className="dropdown-item d-flex"
                    >
                      <div className="flex-grow-1">
                        <div className="d-flex">
                          <span>{type}</span>
                        </div>
                      </div>
                    </DropdownItem>
                  ))}
              </DropdownMenu>
            </Dropdown>
            <Dropdown
              className="dropdown"
              isOpen={benifitValueDropdown}
              toggle={toggleBenifitValueDropdown}
              tabIndex="1"
              style={{ flex: 1 }}
            >
              <DropdownToggle
                as="button"
                className="btn btn-light arrow-none"
                style={{ borderColor: "#d3d3d3", width: "100%" }}
                disabled={formState === "view" ? true : false}
              >
                <span>{selectedBenefitValue ?? "Benefit Value"}</span>
              </DropdownToggle>
              <DropdownMenu
                as="ul"
                className="list-unstyled w-100 dropdown-menu-list mb-0 overflow-auto"
                style={{ maxHeight: "240px" }}
              >
                <Input
                  type="text"
                  className="form-control search m-auto"
                  placeholder="Search frequency..."
                  value={benefitValueSearchTerm}
                  style={{ borderColor: "#d3d3d3" }}
                  onChange={(e) => setBenefitValueSearchTerm(e.target.value)}
                />
                {filteredBenefitValue &&
                  filteredBenefitValue.map((benefitValue) => (
                    <DropdownItem
                      key={benefitValue}
                      as="li"
                      onClick={() => setSelectedBenefitValue(`${benefitValue}`)}
                      className="dropdown-item d-flex"
                    >
                      <div className="flex-grow-1">
                        <div className="d-flex">
                          <span>{benefitValue}</span>
                        </div>
                      </div>
                    </DropdownItem>
                  ))}
              </DropdownMenu>
            </Dropdown>
          </div>
          <br />
          {selectedBenefitType === "Monetory" ? (
            <BenefitPayRateElement
              formState={formState}
              setPayrate={setPayrate}
              value={payrate}
            />
          ) : (
            <Input
              type="text"
              className="form-control search m-auto"
              placeholder="Enter value..."
              value={payrate}
              style={{ borderColor: "#d3d3d3" }}
              onChange={(e) => setPayrate(e.target.value)}
              disabled={formState === "view" ? true : false}
            />
          )}
        </div>

        <div className="align-self-end">
          {editKey ? (
            <div className="d-flex gap-2">
              <button
                type="button"
                className="btn btn-danger"
                name="add"
                onClick={handleCancel}
                disabled={formState === "view" ? true : false}
              >
                Cancel
              </button>
              <Button
                type="button"
                className="btn btn-success"
                style={{
                  borderRadius: "4px",
                  fontWeight: "500",
                }}
                name="add"
                onClick={() => handleEdit(editKey)}
                disabled={formState === "view" ? true : false}
              >
                Save
              </Button>
            </div>
          ) : (
            <button
              type="button"
              className="btn btn-success"
              name="add"
              onClick={handleAdd}
              disabled={formState === "view" ? true : false}
            >
              Add
            </button>
          )}
        </div>
        <div>
          <BenefitTableElement
            formState={formState}
            tableData={tableData}
            handleDel={handleDel}
            handleEdit={handleEditTable}
          />
        </div>
      </div>
    </div>
  );
};

export default BenefitsCustomElement;
